import { defineElement } from '~/utils/gw-utils';

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      // Capture the exact button that was clicked, or use the pre-defined button
      const clickedButton = event.target.closest('button') || this.button;

      // Get modal element
      const modalSelector = this.getAttribute('data-modal');
      const modal = document.querySelector(modalSelector);

      if (modal) {
        // Pass the clicked button as the opener element
        modal.show(clickedButton);

        // Store the button element in localStorage for additional fallback recovery
        if (clickedButton && modalSelector) {
          try {
            // Store the selector of the clicked button for later recovery if needed
            const buttonId = clickedButton.id || 'modal-trigger-' + modalSelector.replace('#', '');
            if (!clickedButton.id) {
              // Add ID if it doesn't have one
              clickedButton.id = buttonId;
            }
            localStorage.setItem('lastModalOpener', buttonId);
          } catch (e) {
            console.warn('Could not store modal opener in localStorage', e);
          }
        }
      }
    });
  }
}

defineElement('modal-opener', ModalOpener);
